import Auth from "@aws-amplify/auth";

export async function Init(): Promise<void> {
  const config = {
    stage: "gamma",
    aws_cognito_region: "eu-west-1",
    aws_cognito_identity_pool_id: "eu-west-1:966c44be-f8dc-49d7-a2b9-e914b90dd514",
    aws_user_pools_id: "eu-west-1_bMJfzrODY",
    aws_user_pools_web_client_id: "62riain1h8f1vsbuc9bg1fkdhb",
    Auth: {
      identityPoolId: "eu-west-1:966c44be-f8dc-49d7-a2b9-e914b90dd514",
      region: "eu-west-1",
      userPoolId: "eu-west-1_bMJfzrODY",
      userPoolWebClientId: "62riain1h8f1vsbuc9bg1fkdhb",
    },
    oauth: {
      domain: "whs-safer-gamma-eu.auth.eu-west-1.amazoncognito.com",
      redirectSignIn: "https://gamma.eu.safer.whs.amazon.dev",
      redirectSignOut: "https://gamma.eu.safer.whs.amazon.dev",
      scope: ["openid", "profile"],
      responseType: "code",
    },
  };

  // BETA/LOCAL ONLY: the Hydra/Cypress integration test authenticates as a SAAM
  // service identity (svc-mw-...-midwaysaam) that has NO email. The identity
  // pool's authenticated role (AmazonQBusinessCognitoRole) requires an `Email`
  // session tag mapped from the token's `email` claim; with no email, the role
  // assume fails ("Invalid identity pool configuration") and Amplify emits
  // signIn_failure so the app never authenticates. The frontend does not use
  // identity-pool (IAM) credentials, so we drop the identity pool on beta/local
  // and let sign-in complete on the User Pool alone. Gamma/prod are unchanged.
  // Local/dev builds resolve gamma to "test".
  const stage = "gamma".toLowerCase();
  const skipIdentityPool = stage === "beta" || stage === "test";

  if (skipIdentityPool) {
    delete (config as { aws_cognito_identity_pool_id?: string })
      .aws_cognito_identity_pool_id;
    delete (config.Auth as { identityPoolId?: string }).identityPoolId;
  }

  Auth.configure(config);
}
